import { useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import Poc from "./components/POC/Poc";
import GstBasedKyc from "./components/BasicKyc/GstBasedKyc/GstBasedKyc";
import AdvancedKyc from "./components/AdvancedKyc/AdvancedKyc";
import DocPreview from "./components/DocPreview/DocPreview";
import DraggablePreviewTest from "./components/DocPreview/DraggablePreviewTest";
import TermsAndConditions from "./components/TermsAndCondition/TermsAndConditions";

const META = {
  "/transaction": {
    title: "Digital Escrow",
    description: "Welcome to the home page",
  },
  "/basic-kyc": {
    title: "Basic Kyc",
    description: "Complete your basic KYC process",
  },
};

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);

    // Minimal meta handling
    const cfg = META[pathname];
    if (cfg?.title) document.title = cfg.title;
    if (cfg?.description) {
      const tag = document.querySelector('head > meta[name="description"]');
      if (tag) tag.content = cfg.description;
    }
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/basic-kyc" replace />} />
      <Route element={<Layout />}>
        <Route path="/basic-kyc" element={<Poc />} />
        <Route path="/basic-kyc/verify" element={<GstBasedKyc />} />
        {/* <Route path="c" element={<AdvancedKyc />} /> */}
        {/* <Route path="/advanced-kyc/document-preview" element={<DocPreview />} /> */}
        {/* <Route path="/termsAndCondition" element={<TermsAndConditions />} /> */}
        {/* <Route path="/advanced-kyc/document-preview" element={<DraggablePreviewTest />} /> */}
      </Route>
    </Routes>
  );
}

export default App;
